export const newTutorItemId = (): string => crypto.randomUUID();
